import React, { useState } from "react";
import { useRefinementList, useInstantSearch } from "react-instantsearch";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FondsModal from "./FondsModal";
import TriStateSwitch, { STATE_NONE, STATE_INCLUDE, STATE_EXCLUDE } from "./TriStateSwitch";

/** Détermine l'état du switch pour un item à partir du refinementList */
function getItemState(itemValue, refinementList) {
  const list = refinementList || [];
  if (list.includes("NOT:" + itemValue)) return STATE_EXCLUDE;
  if (list.includes(itemValue)) return STATE_INCLUDE;
  return STATE_NONE;
}

export default function FondsTriStateFacet({ attribute, searchable = true, searchablePlaceholder = "Filtrer les fonds...", limit = 10, showMoreLimit = 100 }) {
  const { items: rawItems, refine } = useRefinementList({ attribute, limit, showMoreLimit });
  const { indexUiState } = useInstantSearch();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMounted, setModalMounted] = useState(false);

  // Filtrer les items fantômes "NOT:" créés par le mécanisme d'exclusion
  const items = rawItems.filter((it) => !it.value.startsWith("NOT:"));

  const refinementList = indexUiState.refinementList?.[attribute] || [];

  const handleSwitchChange = (value, newState) => {
    if (newState === STATE_INCLUDE) {
      // Retirer l'exclusion si elle existe, puis inclure
      if (refinementList.includes("NOT:" + value)) refine("NOT:" + value);
      if (!refinementList.includes(value)) refine(value);
    } else if (newState === STATE_EXCLUDE) {
      // Retirer l'inclusion si elle existe, puis exclure
      if (refinementList.includes(value)) refine(value);
      if (!refinementList.includes("NOT:" + value)) refine("NOT:" + value);
    } else {
      // Retour au neutre : retirer les deux
      if (refinementList.includes(value)) refine(value);
      if (refinementList.includes("NOT:" + value)) refine("NOT:" + value);
    }
  };

  return (
    <>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <legend className="sui-facet__title">Fonds</legend>
        </AccordionSummary>
        <AccordionDetails>
          <div className="sui-multi-checkbox-facet">
            {items.length === 0 && (
              <div style={{ fontSize: "0.875rem", color: "#666" }}>Aucun fonds trouvé</div>
            )}
            {items.map((item) => {
              const state = getItemState(item.value, refinementList);
              return (
                <label key={item.value} className="sui-multi-checkbox-facet__option-label">
                  <div className="sui-multi-checkbox-facet__option-input-wrapper" style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <TriStateSwitch value={state} onChange={(s) => handleSwitchChange(item.value, s)} />
                    <span className="sui-multi-checkbox-facet__input-text">
                      {item.label}
                      {state === STATE_EXCLUDE && (
                        <span style={{ color: "#CC0000", marginLeft: "6px", fontSize: "11px" }}>exclu</span>
                      )}
                    </span>
                  </div>
                  <span className="sui-multi-checkbox-facet__option-count">
                    {item.count.toLocaleString("fr-CH")}
                  </span>
                </label>
              );
            })}
          </div>
          {items.length >= limit && (
            <div style={{ textAlign: "right", marginTop: "8px" }}>
              <button type="button" onClick={() => { setModalMounted(true); setModalOpen(true); }} style={{ background: "none", border: "none", color: "inherit", cursor: "pointer", fontSize: "0.75rem", textDecoration: "underline" }}>
                Tout afficher
              </button>
            </div>
          )}
        </AccordionDetails>
      </Accordion>
      {modalMounted && (
        <FondsModal
          attribute={attribute}
          searchable={searchable}
          searchablePlaceholder={searchablePlaceholder}
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          modalLimit={showMoreLimit}
        />
      )}
    </>
  );
}
